import axios from 'axios';

// Use the same domain as the dashboard is served from
const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

export const callsApi = {
  getAllCalls: (params?: any) => api.get('/api/calls', { params }),
  getCallById: (callId: string) => api.get(`/api/calls/${callId}`),
  updateCallback: (callId: string, data: any) => api.post(`/api/callbacks/${callId}`, data),
  getCustomers: () => api.get('/api/customers'),
};

export const analyticsApi = {
  getMetrics: (period: string = '72h') => api.get(`/api/analytics/metrics?period=${period}`),
  getDetailed: (period: string = '72h') => api.get(`/api/analytics/detailed?period=${period}`),
  getLive: () => api.get(`/api/analytics/live`),
  getSLA: (period: string = '72h') => api.get(`/api/analytics/sla?period=${period}`),
  getCategorization: (period: string = '72h') => api.get(`/api/analytics/categorization?period=${period}`),
  // Legacy endpoints for backward compatibility
  getOverview: (period: string = '30d') => api.get(`/api/analytics?period=${period}&endpoint=overview`),
  getGeographic: (period: string = '30d') => api.get(`/api/analytics?period=${period}&endpoint=geographic`),
  getTrends: (period: string = '30d') => api.get(`/api/analytics?period=${period}&endpoint=trends`),
};

export const dashboardApi = {
  getDashboard: (period: string = '30d', includeTest: boolean = false) =>
    api.get(`/api/analytics/dashboard?period=${period}&include_test=${includeTest}`),
};

export const nextStepsApi = {
  getNextSteps: (period: string = '72h') => api.get(`/api/analytics/next-steps?period=${period}`),
  // Legacy endpoint
  getNextStepsLegacy: (period: string = '24h') => api.get(`/api/next-steps?period=${period}`),
};

export default api;
